/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-11-08 13:45:08
 */
import defaultSettings from "@/settings";
import variables from "@/styles/color.scss";
import i18n from "@/assets/lang";
import { setLang } from "@/utils/auth";
import { application } from "@/api/other/sysManage";

const { showSettings, fixedHeader, sidebarLogo } = defaultSettings;

const state = {
  theme: variables.themeGreen,
  showSettings,
  fixedHeader,
  tagsView: true,
  sidebarLogo,
  toDoShow: false,
  messageShow: false,
  warnshow: false,
  routerapp: "root",
  openAttachmentNotify: false,
  showExportTask: false
};

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  },
  CHANGE_LANG: (state, data) => {
    i18n.locale = data;
    setLang(data);
  },
  CHANGE_EXPORT_TASK: (state, data) => {
    state.showExportTask = data;
  }
};

const actions = {
  changeSetting({ commit }, data) {
    commit("CHANGE_SETTING", data);
  },
  getSetting({ commit }, data) {
    return new Promise((resolve, reject) => {
      application.getUserSetting().then(res => {
        if (res.code === 200) {
          const data = res.data.labelShow;
          if (data && data.length > 0) {
            if (data.includes("toDoShow")) {
              commit("CHANGE_SETTING", {
                key: "toDoShow",
                value: true
              });
            };
            if (data.includes("messageShow")) {
              commit("CHANGE_SETTING", {
                key: "messageShow",
                value: true
              });
            }
            if (data.includes("warnshow")) {
              commit("CHANGE_SETTING", {
                key: "warnshow",
                value: true
              });
            }
            if (data.includes("tagsView")) {
              commit("CHANGE_SETTING", {
                key: "tagsView",
                value: true
              });
            }
            if (data.includes("zh")) {
              commit("CHANGE_LANG", "zh");
            }
            if (data.includes("en")) {
              commit("CHANGE_LANG", "en");
            }
            if (data[data.length - 1].indexOf("#")) {
              commit("CHANGE_SETTING", {
                key: "theme",
                value: data[data.length - 1]
              });
            }
          }
        }
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};

